import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle } from 'react-icons/fi';

const About = () => {
  return (
    <section id="about" className="py-32 bg-brand-black text-white overflow-hidden relative">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-purple/5 skew-x-12 translate-x-32" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div className="relative">
            <motion.div 
              initial={{ opacity: 0, rotate: -5 }}
              whileInView={{ opacity: 1, rotate: 0 }}
              className="relative z-10"
            >
              <img 
                src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
                alt="Becky - RG Leadership" 
                className="rounded-[3rem] shadow-2xl border-8 border-white/5 h-[600px] w-full object-cover"
              />
            </motion.div>
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-brand-purple rounded-full blur-[100px] opacity-20" />
          </div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
          >
            <span className="text-brand-purple font-black tracking-[0.4em] uppercase text-sm mb-6 block">Why I Do This</span>
            <h2 className="text-5xl font-black mb-8 leading-tight">
              Honest Leadership. <br />
              <span className="text-brand-purple">Real Results.</span>
            </h2>
            <div className="space-y-6 text-gray-300 font-medium leading-relaxed mb-10">
              <p>
                For years, I watched talented, caring people step into leadership roles with big expectations—and very little support. They were promoted for being excellent at their job, then suddenly asked to manage people without a playbook.
              </p>
              <p>
                I started RG Leadership because I believe leaders deserve better than “figure it out as you go.” You deserve tools that make sense, language that sticks, and a guide who walks alongside you.
              </p>
            </div>
            
            <div className="space-y-4 mb-12">
              {[
                "Clarity over complexity: Simple, visual tools.",
                "Transformation over information: Real behavior change.",
                "People over performance-only: Healthy cultures thrive."
              ].map((item, i) => (
                <div key={i} className="flex items-center space-x-4 group">
                  <div className="w-6 h-6 bg-brand-purple/20 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-brand-purple transition-colors">
                    <SafeIcon icon={FiCheckCircle} className="text-brand-purple group-hover:text-white w-4 h-4" />
                  </div>
                  <span className="text-lg font-bold text-gray-200">{item}</span>
                </div>
              ))}
            </div>
            
            <button className="bg-brand-purple text-white px-10 py-5 rounded-2xl font-black text-lg hover:scale-105 transition-all shadow-2xl shadow-purple-600/20">
              MEET BECKY
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;